"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
//import * as $ from "jquery";
const cash_dom_1 = __importDefault(require("cash-dom"));
const bigimage_1 = require("./bigimage");
const slider_1 = require("./slider");
const videoPlay_1 = require("./videoPlay");
const imagecarousel_1 = require("./imagecarousel");
const scrollFix_1 = require("./scrollFix");
const eventdateScroll_1 = require("./eventdateScroll");
const clickRel_1 = require("./clickRel");
const share_1 = require("./share");
const search_1 = require("./search");
const gallery_1 = require("./gallery");
const homepageVideo_1 = require("./homepageVideo");
const spotify_1 = require("./spotify");
require('./bootstrap');
(0, cash_dom_1.default)(function () {
    var _a;
    let bigimage = new bigimage_1.Bigimage((0, cash_dom_1.default)('#bigimage'));
    let homeSliderProgram = new slider_1.Slider((0, cash_dom_1.default)('#program .slider'));
    let homeSliderNews = new slider_1.Slider((0, cash_dom_1.default)('#news .slider'));
    let homeSliderVideos = new slider_1.Slider((0, cash_dom_1.default)('#videos .slider'));
    let imagecarousel = new imagecarousel_1.Imagecarousel((0, cash_dom_1.default)('#imagecarousel'));
    let scrollfix = new scrollFix_1.ScrollFix((0, cash_dom_1.default)('#calendar'));
    let eventdateScroll = new eventdateScroll_1.EventdateScroll((0, cash_dom_1.default)('#eventdates'));
    let clickRel = new clickRel_1.ClickRel((0, cash_dom_1.default)('.click-rel'));
    let videoPlay = new videoPlay_1.VideoPlay((0, cash_dom_1.default)('#videos'));
    let shareBox = new share_1.Share((0, cash_dom_1.default)('#sharebox'));
    let search = new search_1.Search((0, cash_dom_1.default)('#search'));
    let gallery = new gallery_1.Gallery((0, cash_dom_1.default)('#image-gallery'));
    let homepageVideo = new homepageVideo_1.HomepageVideo((0, cash_dom_1.default)('#homepage-video'));
    let spotify = new spotify_1.Spotify((0, cash_dom_1.default)('.spotify'));
    // let masonry = new MasonryFab($('.masonry-grid'));
    // focus search field
    (_a = (0, cash_dom_1.default)('#search-form input[name=term]')[0]) === null || _a === void 0 ? void 0 : _a.focus();
    // custom elements
    //const fabDropdown = new FabDropdownElement();
});
/*$(function () {
  console.log('done')

  // $('html').addClass ( 'dom-loaded' );
  // $('<footer>Appended with Cash</footer>').appendTo ( document.body );

});*/
//document.onscroll = (event) => { console.log(event); };
//window.onscroll = (event) => { console.log(event); };
// $('body').on('scroll', (event) => { console.log(event, $('#app').offset()); });
